"use strict";

function _slicedToArray(r, e) {
  return (
    _arrayWithHoles(r) ||
    _iterableToArrayLimit(r, e) ||
    _unsupportedIterableToArray(r, e) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return (
      "Object" === t && r.constructor && (t = r.constructor.name),
      "Map" === t || "Set" === t
        ? Array.from(r)
        : "Arguments" === t ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
        ? _arrayLikeToArray(r, a)
        : void 0
    );
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r
      ? null
      : ("undefined" != typeof Symbol && r[Symbol.iterator]) || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else
        for (
          ;
          !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l);
          f = !0
        );
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t["return"] && ((u = t["return"]()), Object(u) !== u))
          return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return (
      _regeneratorDefine2(
        u,
        "_invoke",
        (function (r, n, o) {
          var i,
            c,
            u,
            f = 0,
            p = o || [],
            y = !1,
            G = {
              p: 0,
              n: 0,
              v: e,
              a: d,
              f: d.bind(e, 4),
              d: function d(t, r) {
                return (i = t), (c = 0), (u = e), (G.n = r), a;
              },
            };
          function d(r, n) {
            for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
              var o,
                i = p[t],
                d = G.p,
                l = i[2];
              r > 3
                ? (o = l === n) &&
                  ((u = i[(c = i[4]) ? 5 : ((c = 3), 3)]), (i[4] = i[5] = e))
                : i[0] <= d &&
                  ((o = r < 2 && d < i[1])
                    ? ((c = 0), (G.v = n), (G.n = i[1]))
                    : d < l &&
                      (o = r < 3 || i[0] > n || n > l) &&
                      ((i[4] = r), (i[5] = n), (G.n = l), (c = 0)));
            }
            if (o || r > 1) return a;
            throw ((y = !0), n);
          }
          return function (o, p, l) {
            if (f > 1) throw TypeError("Generator is already running");
            for (
              y && 1 === p && d(p, l), c = p, u = l;
              (t = c < 2 ? e : u) || !y;

            ) {
              i ||
                (c
                  ? c < 3
                    ? (c > 1 && (G.n = -1), d(c, u))
                    : (G.n = u)
                  : (G.v = u));
              try {
                if (((f = 2), i)) {
                  if ((c || (o = "next"), (t = i[o]))) {
                    if (!(t = t.call(i, u)))
                      throw TypeError("iterator result is not an object");
                    if (!t.done) return t;
                    (u = t.value), c < 2 && (c = 0);
                  } else
                    1 === c && (t = i["return"]) && t.call(i),
                      c < 2 &&
                        ((u = TypeError(
                          "The iterator does not provide a '" + o + "' method"
                        )),
                        (c = 1));
                  i = e;
                } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
              } catch (t) {
                (i = e), (c = 1), (u = t);
              } finally {
                f = 1;
              }
            }
            return { value: t, done: y };
          };
        })(r, o, i),
        !0
      ),
      u
    );
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n]
      ? t(t([][n]()))
      : (_regeneratorDefine2((t = {}), n, function () {
          return this;
        }),
        t),
    u =
      (GeneratorFunctionPrototype.prototype =
      Generator.prototype =
        Object.create(c));
  function f(e) {
    return (
      Object.setPrototypeOf
        ? Object.setPrototypeOf(e, GeneratorFunctionPrototype)
        : ((e.__proto__ = GeneratorFunctionPrototype),
          _regeneratorDefine2(e, o, "GeneratorFunction")),
      (e.prototype = Object.create(u)),
      e
    );
  }
  return (
    (GeneratorFunction.prototype = GeneratorFunctionPrototype),
    _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype),
    _regeneratorDefine2(
      GeneratorFunctionPrototype,
      "constructor",
      GeneratorFunction
    ),
    (GeneratorFunction.displayName = "GeneratorFunction"),
    _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"),
    _regeneratorDefine2(u),
    _regeneratorDefine2(u, o, "Generator"),
    _regeneratorDefine2(u, n, function () {
      return this;
    }),
    _regeneratorDefine2(u, "toString", function () {
      return "[object Generator]";
    }),
    (_regenerator = function _regenerator() {
      return { w: i, m: f };
    })()
  );
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  (_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r
      ? i
        ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t })
        : (e[r] = n)
      : (o("next", 0), o("throw", 1), o("return", 2));
  }),
    _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
// unified-search.js
(function () {
  var ICON = {
    profiles: '<i class="fa-regular fa-face-smile"></i>',
    branches: '<i class="fa-regular fa-user-hair"></i>',
    locations: '<i class="fa-regular fa-location-dot"></i>',
  };
  function esc(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[c];
    });
  }
  function hi(text, q) {
    if (!q) return esc(text);
    var i = (text || "").toLowerCase().indexOf(q.toLowerCase());
    if (i === -1) return esc(text);
    return (
      esc(text.slice(0, i)) +
      "<strong>" +
      esc(text.slice(i, i + q.length)) +
      "</strong>" +
      esc(text.slice(i + q.length))
    );
  }
  var debounce = function debounce(fn) {
    var ms =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 160;
    var t;
    return function () {
      for (
        var _len = arguments.length, a = new Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        a[_key] = arguments[_key];
      }
      clearTimeout(t);
      t = setTimeout(function () {
        return fn.apply(void 0, a);
      }, ms);
    };
  };
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".nhm-search").forEach(init);
  });
  function init(root) {
    var input = root.querySelector('.nhm-input, input[type="search"]');
    var panel = root.querySelector(".nhm-autocomplete");
    var useBtn = root.querySelector(".nhm-use-my-location");
    if (!input || !panel) return;
    var flat = [],
      idx = -1,
      qLatest = 0;

    // Config / Places availability
    var cfg = window.UNIFIED_SEARCH_CFG || {};

    // country lock: default US, allow override via UNIFIED_SEARCH_CFG.places.country
    var country =
      cfg.places && cfg.places.country
        ? String(cfg.places.country).toLowerCase()
        : "us";
    var placesSvc = null,
      placesAuto = null;
    function ensurePlaces() {
      if (placesSvc && placesAuto) return;
      if (
        !(
          window.google &&
          google.maps &&
          google.maps.places &&
          google.maps.places.PlacesService &&
          google.maps.places.AutocompleteService
        )
      ) {
        return;
      }
      try {
        placesSvc = new google.maps.places.PlacesService(
          document.createElement("div")
        );
        placesAuto = new google.maps.places.AutocompleteService();
      } catch (e) {
        placesSvc = null;
        placesAuto = null;
      }
    }
    input.addEventListener("input", function () {
      return fetchAll(input.value.trim());
    });
    input.addEventListener("keydown", onKey);
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) hide();
    });
    if (useBtn) useBtn.addEventListener("click", onUseMyLocation);
    function setGeoNotice(msg) {
      var withReload =
        arguments.length > 1 && arguments[1] !== undefined
          ? arguments[1]
          : false;
      var wrap = root.querySelector(".nhm-actions");
      if (!wrap) return;
      var n = wrap.querySelector(".nhm-geo-notice");
      if (!n) {
        n = document.createElement("div");
        n.className = "nhm-geo-notice alert alert-warning mt-3 p-2 small";
        wrap.appendChild(n);
      }
      n.innerHTML = msg
        ? String(msg) +
          (withReload ? ' <a href="#" class="nhm-geo-reload">Reload</a>' : "")
        : "";
      if (withReload) {
        var a = n.querySelector(".nhm-geo-reload");
        if (a)
          a.addEventListener("click", function (e) {
            e.preventDefault();
            window.location.reload();
          });
      }
    }
    function onKey(e) {
      if (panel.hidden) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        move(1);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        move(-1);
      } else if (e.key === "Enter") {
        e.preventDefault();
        go();
      } else if (e.key === "Escape") {
        hide();
      }
    }
    function move(d) {
      if (!flat.length) return;
      idx = (idx + d + flat.length) % flat.length;
      panel.querySelectorAll('[role="option"]').forEach(function (el, i) {
        el.classList.toggle("is-active", i === idx);
        if (i === idx)
          el.scrollIntoView({
            block: "nearest",
          });
      });
    }
    function go() {
      var it = flat[idx] || flat[0];
      if (!it) return;
      if (it.type === "profile" && it.url) {
        location.href = it.url;
      } else if (it.type === "branch" && it.branch_url) {
        location.href = it.branch_url;
      } else if (it.type === "branch" && it.listing_url) {
        location.href = it.listing_url;
      } else if (it.type === "location" && it.place_id) {
        resolvePlaceThenRedirect(it.place_id);
      }
    }
    function hide() {
      panel.hidden = true;
      panel.innerHTML = "";
      flat = [];
      idx = -1;
    }

    // Validate the chosen place → normalized address + lat/lng → redirect
    function resolvePlaceThenRedirect(placeId) {
      ensurePlaces();
      if (!placesSvc) return;
      try {
        placesSvc.getDetails(
          {
            placeId: placeId,
            fields: ["geometry", "formatted_address"],
          },
          function (place, status) {
            if (
              status !== "OK" ||
              !place ||
              !place.geometry ||
              !place.geometry.location
            )
              return;
            var lat = place.geometry.location.lat(),
              lng = place.geometry.location.lng();
            var base = (cfg.listing && cfg.listing.profiles_url) || "/";
            var url = new URL(base, window.location.origin);
            url.searchParams.set("lat", lat);
            url.searchParams.set("lng", lng);
            if (place.formatted_address)
              url.searchParams.set("address", place.formatted_address);
            location.href = url.toString();
          }
        );
      } catch (e) {}
    }

    // Use browser geolocation and optional reverse geocode, then redirect
    function onUseMyLocation() {
      if (!navigator.geolocation) return;
      useBtn.disabled = true;
      navigator.geolocation.getCurrentPosition(
        /*#__PURE__*/ (function () {
          var _ref = _asyncToGenerator(
            /*#__PURE__*/ _regenerator().m(function _callee(pos) {
              var lat,
                lng,
                addr,
                geocoder,
                _yield$geocoder$geoco,
                results,
                base,
                url,
                _t;
              return _regenerator().w(
                function (_context) {
                  while (1)
                    switch ((_context.p = _context.n)) {
                      case 0:
                        _context.p = 0;
                        (lat = pos.coords.latitude),
                          (lng = pos.coords.longitude);
                        addr = "";
                        if (
                          !(
                            window.google &&
                            google.maps &&
                            google.maps.Geocoder
                          )
                        ) {
                          _context.n = 4;
                          break;
                        }
                        _context.p = 1;
                        geocoder = new google.maps.Geocoder();
                        _context.n = 2;
                        return geocoder.geocode({
                          location: {
                            lat: lat,
                            lng: lng,
                          },
                        });
                      case 2:
                        _yield$geocoder$geoco = _context.v;
                        results = _yield$geocoder$geoco.results;
                        if (
                          Array.isArray(results) &&
                          results[0] &&
                          results[0].formatted_address
                        ) {
                          addr = results[0].formatted_address;
                        }
                        _context.n = 4;
                        break;
                      case 3:
                        _context.p = 3;
                        _t = _context.v;
                      case 4:
                        base = (cfg.listing && cfg.listing.profiles_url) || "/";
                        url = new URL(base, window.location.origin);
                        url.searchParams.set("lat", lat);
                        url.searchParams.set("lng", lng);
                        if (addr) url.searchParams.set("address", addr);
                        location.href = url.toString();
                      case 5:
                        _context.p = 5;
                        useBtn.disabled = false;
                        setGeoNotice("");
                        return _context.f(5);
                      case 6:
                        return _context.a(2);
                    }
                },
                _callee,
                null,
                [
                  [1, 3],
                  [0, , 5, 6],
                ]
              );
            })
          );
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        })(),
        function (err) {
          useBtn.disabled = false;
          var code = (err && err.code) || 0;
          if (code === 1) {
            setGeoNotice(
              "Location blocked. Enable in your browser's site settings, then",
              true
            );
          } else if (code === 3) {
            setGeoNotice("Location timed out. Try again or enter a place.");
          } else {
            setGeoNotice("Unable to get location. Enter a place instead.");
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 8000,
          maximumAge: 60000,
        }
      );
    }

    // ----------------- Places helpers -----------------
    function looksLikePostal(q) {
      var us = /^\d{5}(?:-\d{4})?$/; // 53012 or 53012-1234
      var ca = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/; // A1A 1A1
      return us.test(q) || ca.test(q);
    }
    function looksLikeStreet(q) {
      var s = q.toLowerCase();
      if (/\d/.test(s)) return true; // number often implies an address
      return /\b(st|street|ave|avenue|rd|road|ln|lane|dr|drive|ct|court|blvd|hwy|pkwy|#)\b/.test(
        s
      );
    }
    function looksLikeRegion(q) {
      if (looksLikePostal(q)) return true;
      if (looksLikeStreet(q)) return false;
      var words = q.split(/[,\s]+/).filter(Boolean);
      return words.length <= 3;
    }
    function askPredictions(q, type) {
      return new Promise(function (res) {
        ensurePlaces();
        if (!placesAuto) {
          res([]);
          return;
        }
        try {
          var req = {
            input: q,
            componentRestrictions: {
              country: country,
            },
          }; // force US (or override)
          if (type) req.types = [type]; // single type only
          placesAuto.getPlacePredictions(req, function (preds) {
            res(Array.isArray(preds) ? preds : []);
          });
        } catch (e) {
          res([]);
        }
      });
    }
    // Simple wrapper: fetch predictions for any query and
    // map them into our unified "location" shape.
    function getPredictionsSimple(q) {
      ensurePlaces();
      return askPredictions(q, null).then(function (arr) {
        return (Array.isArray(arr) ? arr : [])
          .map(function (p) {
            var _p$structured_formatt, _p$structured_formatt2;
            return {
              type: "location",
              id: p.place_id,
              label:
                p.description ||
                ((_p$structured_formatt = p.structured_formatting) === null ||
                _p$structured_formatt === void 0
                  ? void 0
                  : _p$structured_formatt.main_text) ||
                "",
              sub:
                ((_p$structured_formatt2 = p.structured_formatting) === null ||
                _p$structured_formatt2 === void 0
                  ? void 0
                  : _p$structured_formatt2.secondary_text) || "",
              place_id: p.place_id,
            };
          })
          .filter(function (x) {
            return x.label;
          });
      });
    }
    var fetchAll = debounce(
      /*#__PURE__*/ (function () {
        var _ref2 = _asyncToGenerator(
          /*#__PURE__*/ _regenerator().m(function _callee3(q) {
            var myId,
              perGroup,
              restURL,
              wpReq,
              placesReq,
              _yield$Promise$all,
              _yield$Promise$all2,
              wpData,
              locs,
              locations;
            return _regenerator().w(function (_context3) {
              while (1)
                switch (_context3.n) {
                  case 0:
                    if (!(!q || q.length < 2)) {
                      _context3.n = 1;
                      break;
                    }
                    hide();
                    return _context3.a(2);
                  case 1:
                    myId = ++qLatest;
                    perGroup = (cfg.limits && cfg.limits.per_group) || 3; // WP profiles + branches (add cache-buster)
                    restURL =
                      cfg.rest && cfg.rest.endpoint
                        ? ""
                            .concat(cfg.rest.endpoint, "?q=")
                            .concat(encodeURIComponent(q), "&limit=")
                            .concat(perGroup, "&_cb=")
                            .concat(Date.now())
                        : null;
                    wpReq = restURL
                      ? fetch(restURL, {
                          credentials: "same-origin",
                        })
                          .then(
                            /*#__PURE__*/ (function () {
                              var _ref3 = _asyncToGenerator(
                                /*#__PURE__*/ _regenerator().m(
                                  function _callee2(r) {
                                    var text, _t2;
                                    return _regenerator().w(
                                      function (_context2) {
                                        while (1)
                                          switch ((_context2.p = _context2.n)) {
                                            case 0:
                                              if (r.ok) {
                                                _context2.n = 1;
                                                break;
                                              }
                                              console.warn(
                                                "AUS search REST error",
                                                r.status,
                                                r.statusText
                                              );
                                              return _context2.a(2, {
                                                profiles: [],
                                                branches: [],
                                              });
                                            case 1:
                                              _context2.n = 2;
                                              return r.text();
                                            case 2:
                                              text = _context2.v;
                                              _context2.p = 3;
                                              return _context2.a(
                                                2,
                                                JSON.parse(text)
                                              );
                                            case 4:
                                              _context2.p = 4;
                                              _t2 = _context2.v;
                                              console.warn(
                                                "AUS search parse error",
                                                _t2,
                                                text && text.slice
                                                  ? text.slice(0, 180)
                                                  : ""
                                              );
                                              return _context2.a(2, {
                                                profiles: [],
                                                branches: [],
                                              });
                                          }
                                      },
                                      _callee2,
                                      null,
                                      [[3, 4]]
                                    );
                                  }
                                )
                              );
                              return function (_x4) {
                                return _ref3.apply(this, arguments);
                              };
                            })()
                          )
                          ["catch"](function (err) {
                            console.warn("AUS search fetch failed", err);
                            return {
                              profiles: [],
                              branches: [],
                            };
                          })
                      : Promise.resolve({
                          profiles: [],
                          branches: [],
                        }); // Places predictions (region-only when region input; otherwise addresses)
                    var canUsePlacesNow =
                      !!(cfg && cfg.hasPlaces) &&
                      !!(
                        window.google &&
                        google.maps &&
                        google.maps.places &&
                        google.maps.places.AutocompleteService
                      );
                    placesReq = canUsePlacesNow
                      ? getPredictionsSimple(q)
                      : Promise.resolve([]);
                    _context3.n = 2;
                    return Promise.all([wpReq, placesReq]);
                  case 2:
                    _yield$Promise$all = _context3.v;
                    _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                    wpData = _yield$Promise$all2[0];
                    locs = _yield$Promise$all2[1];
                    if (!(myId !== qLatest)) {
                      _context3.n = 3;
                      break;
                    }
                    return _context3.a(2);
                  case 3:
                    // discard stale
                    locations = (locs || []).slice(0, perGroup);
                    render(
                      {
                        locations: locations,
                        profiles: wpData.profiles || [],
                        branches: wpData.branches || [],
                      },
                      q
                    );
                  case 4:
                    return _context3.a(2);
                }
            }, _callee3);
          })
        );
        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      })()
    );
    function render(data, q) {
      var _data$locations, _data$profiles, _data$branches;
      flat = [];
      var groups = [
        {
          key: "locations",
          title: "Address",
          icon: ICON.locations,
          show: !!(
            (_data$locations = data.locations) !== null &&
            _data$locations !== void 0 &&
            _data$locations.length
          ),
        },
        {
          key: "profiles",
          title: "Loan Officers",
          icon: ICON.profiles,
          show: !!(
            (_data$profiles = data.profiles) !== null &&
            _data$profiles !== void 0 &&
            _data$profiles.length
          ),
        },
        {
          key: "branches",
          title: "Branches",
          icon: ICON.branches,
          show: !!(
            (_data$branches = data.branches) !== null &&
            _data$branches !== void 0 &&
            _data$branches.length
          ),
        },
      ].filter(function (g) {
        return g.show;
      });
      if (!groups.length) {
        hide();
        return;
      }
      var html = groups
        .map(function (g) {
          var arr = data[g.key] || [];
          var items = arr
            .map(function (r) {
              var i = flat.push(r) - 1;
              var left = r.thumb
                ? '<img class="nhm-avatar" src="'.concat(
                    esc(r.thumb),
                    '" alt="">'
                  )
                : '<span class="nhm-ic">'.concat(g.icon, "</span>");
              var sub = r.sub
                ? '<div class="nhm-sub">'.concat(esc(r.sub), "</div>")
                : "";
              var extra = r.place_id
                ? ' data-place="'.concat(esc(r.place_id), '"')
                : "";
              return '\n            <div class="nhm-item" role="option" data-i="'
                .concat(i, '"')
                .concat(extra, ">\n                   ")
                .concat(
                  left,
                  '\n                                 <div class="nhm-label">'
                )
                .concat(hi(r.label, q), "                 ")
                .concat(sub, "\n          </div>\n                </div>");
            })
            .join("");
          return '\n          <div class="nhm-group">\n            <div class="nhm-head">'
            .concat(g.title, "</div>\n            ")
            .concat(items, "\n          </div>");
        })
        .join("");
      panel.innerHTML = html;
      panel.hidden = false;
      idx = -1;
      panel.querySelectorAll(".nhm-item").forEach(function (el) {
        el.addEventListener("mousedown", function (e) {
          e.preventDefault();
          var i = +el.getAttribute("data-i");
          var it = flat[i];
          if (!it) return;
          if (it.type === "profile" && it.url) {
            location.href = it.url;
          } else if (it.type === "branch" && it.branch_url) {
            location.href = it.branch_url;
          } else if (it.type === "branch" && it.listing_url) {
            location.href = it.listing_url;
          } else if (it.type === "location" && it.place_id) {
            resolvePlaceThenRedirect(it.place_id);
          }
        });
      });
    }
  }
})();
